import { render, staticRenderFns } from "./TabConfiguratorFileTypes.vue?vue&type=template&id=76bf57ac&"
import script from "./TabConfiguratorFileTypes.vue?vue&type=script&lang=js&"
export * from "./TabConfiguratorFileTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports